(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(60929);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
}).withConfig({
    componentId: "sc-62e22978-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-eecfaa46-1"
}).withConfig({
    componentId: "sc-62e22978-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 12448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.18731 5.68438C2.44993 5.52604 2.44993 4.47393 3.18731 4.31559L5.3203 3.85755C5.58957 3.79973 5.79991 3.58939 5.85774 3.32012L6.31577 1.18713C6.47411 0.449748 7.52622 0.449751 7.68457 1.18713L8.1426 3.32012C8.20042 3.58939 8.41076 3.79973 8.68003 3.85755L10.813 4.31559C11.5504 4.47393 11.5504 5.52604 10.813 5.68438L8.68003 6.14241C8.41076 6.20024 8.20042 6.41058 8.1426 6.67985L7.68457 8.81284C7.52622 9.55022 6.47411 9.55022 6.31577 8.81284L5.85774 6.67985C5.79991 6.41058 5.58957 6.20024 5.3203 6.14241L3.18731 5.68438Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 2.99998C15.866 2.99998 19 6.13399 19 9.99998C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 9.99998C5 9.4477 4.55228 8.99998 4 8.99998C3.44772 8.99998 3 9.4477 3 9.99998C3 12.8894 4.36163 15.4608 6.47822 17.1075L5.58579 18C5.21071 18.3751 5 18.8838 5 19.4142V21.5C5 22.3284 5.67157 23 6.5 23H17.5C18.3284 23 19 22.3284 19 21.5V19.4142C19 18.8838 18.7893 18.3751 18.4142 18L17.5218 17.1075C19.6384 15.4608 21 12.8894 21 9.99998C21 5.02942 16.9706 0.999985 12 0.999985C11.4477 0.999985 11 1.4477 11 1.99998C11 2.55227 11.4477 2.99998 12 2.99998ZM12 19C10.6564 19 9.38156 18.7056 8.23649 18.1777L7 19.4142L7 21H17V19.4142L15.7635 18.1777C14.6184 18.7056 13.3436 19 12 19Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 24686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11C16 10.45 15.55 10 15 10C14.45 10 14 10.45 14 11V17.01H12.21C11.76 17.01 11.54 17.55 11.86 17.86L14.65 20.64C14.85 20.83 15.16 20.83 15.36 20.64L18.15 17.86C18.47 17.55 18.24 17.01 17.8 17.01H16ZM8.65003 3.35002L5.86003 6.14002C5.54003 6.45002 5.76003 6.99002 6.21003 6.99002H8.00003V13C8.00003 13.55 8.45003 14 9.00003 14C9.55003 14 10 13.55 10 13V6.99002H11.79C12.24 6.99002 12.46 6.45002 12.14 6.14002L9.35003 3.35002C9.16003 3.16002 8.84003 3.16002 8.65003 3.35002Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 57382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.4144 13.4824L9.36944 5.52736L10.0765 6.23446C10.3694 6.52736 10.8443 6.52736 11.1372 6.23446C11.4301 5.94157 11.4301 5.4667 11.1372 5.1738L10.4301 4.4667L12.7281 2.16869C13.5092 1.38764 14.7755 1.38764 15.5565 2.16869L16.6173 3.22943C16.8125 3.42465 16.8125 3.74115 16.6173 3.93637C15.641 4.91268 15.641 6.49559 16.6173 7.4719C17.5936 8.44821 19.1765 8.44821 20.1528 7.4719C20.348 7.27669 20.6645 7.27669 20.8597 7.4719L21.9205 8.53265C22.7015 9.3137 22.7015 10.58 21.9205 11.3611L19.6224 13.6592L18.9153 12.9521C18.6224 12.6592 18.1475 12.6592 17.8546 12.9521C17.5617 13.245 17.5617 13.7198 17.8546 14.0127L18.5617 14.7198L10.6068 22.6748C9.82574 23.4558 8.55941 23.4558 7.77836 22.6748L6.7177 21.6141C6.52244 21.4189 6.52244 21.1023 6.7177 20.907C7.69401 19.9307 7.69401 18.3478 6.7177 17.3715C5.74139 16.3952 4.15848 16.3952 3.18217 17.3715C2.9869 17.5667 2.67032 17.5667 2.47506 17.3715L1.4144 16.3108C0.633351 15.5298 0.633351 14.2634 1.4144 13.4824ZM13.2584 7.29521C12.9655 7.00232 12.4907 7.00232 12.1978 7.29521C11.9049 7.5881 11.9049 8.06298 12.1978 8.35587L12.9049 9.06298C13.1978 9.35587 13.6727 9.35587 13.9655 9.06298C14.2584 8.77009 14.2584 8.29521 13.9655 8.00232L13.2584 7.29521ZM15.0262 10.1236C15.3191 9.83075 15.794 9.83074 16.0869 10.1236L16.794 10.8307C17.0869 11.1236 17.0869 11.5985 16.794 11.8914C16.5011 12.1843 16.0262 12.1843 15.7333 11.8914L15.0262 11.1843C14.7333 10.8914 14.7333 10.4165 15.0262 10.1236Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 60557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useVaultApy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10253);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20335);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21046);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79833);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toString__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97478);
/* harmony import */ var config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83251);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49770);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8414);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87318);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62712);
/* harmony import */ var _utils_multicall__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9796);















var masterChefAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getMasterChefAddress */ .Oc)();
// default
var DEFAULT_PERFORMANCE_FEE_DECIMALS = 2;
var PRECISION_FACTOR = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .BigNumber.from */ .O$.from("1000000000000");
var getFlexibleApy = function(totalCakePoolEmissionPerYear, pricePerFullShare, totalShares) {
    return totalCakePoolEmissionPerYear.mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(_ethersproject_constants__WEBPACK_IMPORTED_MODULE_13__/* .WeiPerEther */ .Ce)).divUnsafe(pricePerFullShare).divUnsafe(totalShares).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(100));
};
var _getBoostFactor = function(boostWeight, duration, durationFactor) {
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(boostWeight).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(Math.max(duration, 0))).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(durationFactor)).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(PRECISION_FACTOR));
};
var getLockedApy = function(flexibleApy, boostFactor) {
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from("1")));
};
var cakePoolPID = 0;
function useVaultApy() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _duration = ref.duration, duration = _duration === void 0 ? config_constants_pools__WEBPACK_IMPORTED_MODULE_9__/* .MAX_LOCK_DURATION */ .VO : _duration;
    var ref1 = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useCakeVault */ .Xo)(), _totalShares = ref1.totalShares, totalShares = _totalShares === void 0 ? utils_bigNumber__WEBPACK_IMPORTED_MODULE_8__/* .BIG_ZERO */ .HW : _totalShares, _pricePerFullShare = ref1.pricePerFullShare, pricePerFullShare = _pricePerFullShare === void 0 ? utils_bigNumber__WEBPACK_IMPORTED_MODULE_8__/* .BIG_ZERO */ .HW : _pricePerFullShare, tmp = ref1.fees, performanceFeeAsDecimal = (tmp === void 0 ? {
        performanceFeeAsDecimal: DEFAULT_PERFORMANCE_FEE_DECIMALS
    } : tmp).performanceFeeAsDecimal;
    var totalSharesAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(totalShares.toString());
    }, [
        totalShares
    ]);
    var pricePerFullShareAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(pricePerFullShare.toString());
    }, [
        pricePerFullShare
    ]);
    var ref2 = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("masterChef-total-cake-pool-emission", (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var calls, ref, ref1, specialFarmsPerBlock, cakePoolInfo, ref2, totalSpecialAllocPoint, cakePoolSharesInSpecialFarms;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    calls = [
                        {
                            address: masterChefAddress,
                            name: "shdwPerBlock",
                            params: [
                                false
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "poolInfo",
                            params: [
                                cakePoolPID
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "totalSpecialAllocPoint"
                        }, 
                    ];
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_utils_multicall__WEBPACK_IMPORTED_MODULE_10__/* .multicallv2 */ .v)({
                        abi: config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_3__,
                        calls: calls
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(ref[0], 1);
                    specialFarmsPerBlock = ref1[0];
                    cakePoolInfo = ref[1];
                    ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(ref[2], 1);
                    totalSpecialAllocPoint = ref2[0];
                    cakePoolSharesInSpecialFarms = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(cakePoolInfo.allocPoint).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(totalSpecialAllocPoint));
                    return _ctx.abrupt("return", _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(specialFarmsPerBlock).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(config__WEBPACK_IMPORTED_MODULE_2__/* .BLOCKS_PER_YEAR */ .Bi)).mulUnsafe(cakePoolSharesInSpecialFarms));
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), totalCakePoolEmissionPerYear = ref2.data;
    var flexibleApy = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return totalCakePoolEmissionPerYear && !pricePerFullShareAsEtherBN.isZero() && !totalSharesAsEtherBN.isZero() && getFlexibleApy(totalCakePoolEmissionPerYear, pricePerFullShareAsEtherBN, totalSharesAsEtherBN).toString();
    }, [
        pricePerFullShareAsEtherBN,
        totalCakePoolEmissionPerYear,
        totalSharesAsEtherBN
    ]);
    var boostFactor = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_9__/* .BOOST_WEIGHT */ .xt, duration, config_constants_pools__WEBPACK_IMPORTED_MODULE_9__/* .DURATION_FACTOR */ .A0);
    }, [
        duration
    ]);
    var lockedApy = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return flexibleApy && getLockedApy(flexibleApy, boostFactor).toString();
    }, [
        boostFactor,
        flexibleApy
    ]);
    var getBoostFactor = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(adjustDuration) {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_9__/* .BOOST_WEIGHT */ .xt, adjustDuration, config_constants_pools__WEBPACK_IMPORTED_MODULE_9__/* .DURATION_FACTOR */ .A0);
    }, []);
    var flexibleApyNoFee = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (flexibleApy && performanceFeeAsDecimal) {
            var rewardPercentageNoFee = lodash_toString__WEBPACK_IMPORTED_MODULE_1___default()(1 - performanceFeeAsDecimal / 100);
            return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from(rewardPercentageNoFee)).toString();
        }
        return flexibleApy;
    }, [
        flexibleApy,
        performanceFeeAsDecimal
    ]);
    return {
        flexibleApy: flexibleApyNoFee,
        lockedApy: lockedApy,
        getLockedApy: (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(adjustDuration) {
            return flexibleApy && getLockedApy(flexibleApy, getBoostFactor(adjustDuration)).toString();
        }, [
            flexibleApy,
            getBoostFactor
        ]),
        boostFactor: (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
            return boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            boostFactor
        ]),
        getBoostFactor: (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(adjustDuration) {
            return getBoostFactor(adjustDuration).addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_12__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            getBoostFactor
        ])
    };
}


/***/ }),

/***/ 60929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/styled-jsx/style.js
var style = __webpack_require__(60536);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 2 modules
var PageSection = __webpack_require__(76751);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 30 modules
var wagmi_esm = __webpack_require__(5286);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/home/lunar-bunny/shadow@2xx.png
/* harmony default export */ var shadow_2xx = ({"src":"/_next/static/media/shadow@2xx.946ace77.png","height":1202,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAuklEQVR42mMAgSSnPJlVHbf1DjZ+tmyNagkFicVYL2ACS1qaKZsVBS14X+o6/X+Sk91xBghgBJOuNnHWDNEh/xlivf97qert//jzP1gXGJgWTuTTMfB6K82j+T/YWO8gik5L+8REJSnD/yIMot+tFfX/V/r6uMB1GukEpslI6/9V41f7729ocjbGzsEJJgc2X0pWf7KygPR/bz0tsGttFBWZGAyM/MGShqyOIqYyen3mQqIiIL6tghITAC+wMkSJSNDTAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
};
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16d94d8d-0"
})(_templateObject1(), flyingAnim);
var Hero = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,wagmi_esm/* useAccount */.mA)(), account = ref.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "17b87fe7f0af5ff",
                children: '.slide-svg-dark{display:none}.slide-svg-light{display:block}[data-theme="dark"] .slide-svg-dark{display:block}[data-theme="dark"] .slide-svg-light{display:none}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                position: "relative",
                flexDirection: [
                    "column-reverse",
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "flex-end",
                    null,
                    null,
                    "center"
                ],
                justifyContent: "cente",
                mt: [
                    account ? "50px" : "50px",
                    null,
                    0
                ],
                id: "homepage-hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                ml: "20px",
                                "text-align": "center",
                                children: [
                                    t("#1 Dex on Core Chain"),
                                    t(" From the Shadows.")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                mb: "24px",
                                mt: "-24px",
                                ml: [
                                    "20px",
                                    "20px"
                                ],
                                children: t("ShadowSwap is a one-stop decentralized trading protocol which utilizes the security, scalability, and decentralization of the Core blockchain, creating an open and safe marketplace for traders, liquidity providers, and developers.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                        mr: "8px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                        to: "/swap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: !account ? "secondary" : "primary",
                                            children: t("Trade")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        height: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        width: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        flex: [
                            null,
                            null,
                            null,
                            "1"
                        ],
                        mb: [
                            "24px",
                            null,
                            null,
                            "0"
                        ],
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: shadow_2xx,
                                priority: true,
                                placeholder: "blur",
                                alt: t("Lunar bunny")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/data.ts
var swapSectionData = function(t) {
    return {
        headingText: t("Trade anything. With Fast, Secure Network."),
        bodyText: t("Trade any token on Core Chain in seconds, just by connecting your wallet."),
        reverse: false,
        primaryButton: {
            to: "/swap",
            text: t("Trade Now"),
            external: false
        },
        secondaryButton: {
            to: "https://shadow-11.gitbook.io/shadowswap/",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/trade/",
            attributes: [
                {
                    src: "ETH",
                    alt: t("ETH token")
                },
                {
                    src: "BTC",
                    alt: t("BTC token")
                },
                {
                    src: "Core3D",
                    alt: t("Core3D token")
                }, 
            ]
        }
    };
};
var earnSectionData = function(t) {
    return {
        headingText: t("Earn passive income with your crypto."),
        bodyText: t("ShadowSwap makes it easy to make your crypto work for you. Let your Shadows work for you."),
        reverse: true,
        primaryButton: {
            to: "/farms",
            text: t("Explore"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.shadowswap.xyz/products/yield-farming",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/earn/",
            attributes: [
                {
                    src: "shdwearn",
                    alt: t("Shadow with shdw token")
                }
            ]
        }
    };
};
var nftammSectionData = function(t) {
    return {
        headingText: t("Introducing A Decentralised NFT Marketplace on Core Network."),
        bodyText: t("ShadowSwap AMM NFT Marketplace allows users to trade NFTs in Liquidity Pool thereby Fostering More Defi to NFTs and enabling easy trading of assets. Changing how users perceive NFTs and NFT Trading"),
        reverse: false,
        primaryButton: {
            to: "/nftamm",
            text: t("NFT Dex"),
            external: false
        },
        secondaryButton: {
            to: "https://shadow-11.gitbook.io/shadowswap/products/amm-nft-marketplace",
            text: t("Learn More"),
            external: true
        },
        images: {
            path: "/images/home/nftamm/",
            attributes: [
                {
                    src: "NFT",
                    alt: t("NFT Pic")
                }
            ]
        }
    };
};
var cakeSectionData = function(t) {
    return {
        headingText: t("Cast Your Shadow on your Finances."),
        bodyText: t("Shadow token is at the heart of the ShadowSwap ecosystem, Governing all Shadow Products with Core on its Side . Buy it, farm it, spend it, stake it, borrow it, use it to buy nft or even vote with it!"),
        reverse: false,
        primaryButton: {
            to: "/swap?outputCurrency=0xddBa66C1eBA873e26Ac0215Ca44892a07d83aDF5&chainId=1116",
            text: t("Buy SHDW"),
            external: false
        },
        secondaryButton: {
            to: "https://docs.shadowswap.xyz",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/cake/",
            attributes: [
                {
                    src: "star-bottom-right",
                    alt: t("Small 3d star")
                },
                {
                    src: "star-top-right",
                    alt: t("Small 3d star")
                },
                {
                    src: "SHDW3D",
                    alt: t("SHDW token")
                },
                {
                    src: "star-top-left",
                    alt: t("Small 3d star")
                }, 
            ]
        }
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
;// CONCATENATED MODULE: ./src/views/Home/components/IconCard.tsx




function IconCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  padding: 1px 1px 4px 1px;\n  box-sizing: border-box;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 24px;\n  right: 24px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-fc5f564c-0"
})(IconCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-fc5f564c-1"
})(IconCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconCard = function(_param) {
    var icon = _param.icon, background = _param.background, borderColor = _param.borderColor, rotation = _param.rotation, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "background",
        "borderColor",
        "rotation",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        background: background,
        borderBackground: borderColor,
        rotation: rotation
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                    rotation: rotation,
                    children: icon
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var components_IconCard = (IconCard);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/StatCardContent.tsx


var StatCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    var split = headingText.split(" ");
    var lastWord = split.pop();
    var remainingWords = split.slice(0, split.length).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            "168px"
        ],
        minWidth: "232px",
        width: "fit-content",
        flexDirection: "column",
        justifyContent: "flex-end",
        mt: [
            null,
            null,
            null,
            "64px"
        ],
        children: [
            isSmallerScreen && remainingWords.length > 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                children: remainingWords
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: remainingWords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px",
                children: lastWord
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: bodyText
            })
        ]
    });
};
/* harmony default export */ var MetricsSection_StatCardContent = (StatCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx










var Stats = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    // const tvlText = t('And those users are now entrusting the platform with over $%tvl% in funds.', { tvl: tvlString })
    // const [entrusting, inFunds] = tvlText.split(tvlString)
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "/images/community2.png",
            alt: "Shadowswap",
            className: "Shadow-road",
            width: "36px"
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "/images/trade.png",
            alt: "Shadowswap",
            className: "Shadow-road",
            width: "36px"
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "/images/staked.png",
            alt: "Shadowswap",
            className: "Shadow-road",
            width: "36px"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/shadowhome.png",
                alt: "Shadowswap",
                className: "Shadow-road",
                height: "68px",
                width: "68px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xl",
                children: t("Built on Core Solid Foundation")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xl",
                mb: "32px",
                children: t("Supported By CoreDao.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textAlign: "center",
                color: "textSubtle",
                children: t("ShadowSwap is here to help you cast your shadow onto your finance and ease you in the Defi Verse.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textAlign: "center",
                color: "textSubtle",
                bold: true,
                mb: "32px",
                children: t("Will you join the Shadows?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, UsersCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("%users% users", {
                                users: users
                            }),
                            bodyText: t("in the last 30 days"),
                            highlightColor: theme.colors.secondary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, TradesCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("%trades% trades", {
                                trades: trades
                            }),
                            bodyText: t("made in the last 30 days"),
                            highlightColor: theme.colors.primary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, StakedCardData), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("$%tvl% staked", {
                                tvl: tvlString
                            }),
                            bodyText: t("Total Value Locked"),
                            highlightColor: theme.colors.failure
                        })
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var MetricsSection = (Stats);

;// CONCATENATED MODULE: ./src/views/Home/components/RoadmapSection/StatCardContent.tsx


var StatCardContent_StatCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor, phase = param.phase;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            "168px"
        ],
        minWidth: "232px",
        width: "fit-content",
        flexDirection: "column",
        justifyContent: "flex-end",
        mt: [
            null,
            null,
            null,
            "64px"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: headingText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px",
                textAlign: "center",
                children: [
                    "Phase ",
                    phase
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: bodyText.map(function(point, i) {
                    return(// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        style: {
                            listStyle: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                mr: 2,
                                children: "→"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                children: point
                            })
                        ]
                    }, i));
                })
            })
        ]
    });
};
/* harmony default export */ var RoadmapSection_StatCardContent = (StatCardContent_StatCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/RoadmapSection/index.tsx






var Roadmap = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xl",
                py: 4,
                children: t("Initial Roadmap 1")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/road.png",
                            alt: "Shadowswap",
                            className: "Shadow-road"
                        }),
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoadmapSection_StatCardContent, {
                            headingText: t(""),
                            bodyText: [
                                t("Initial ShadowSwap Dex Launch"),
                                t("Release of Whitelist Campaign for IFO private sale allocations"),
                                t("Shadow Token Airdrop Announcement and Procedure"),
                                t("ShadowSwap IFO Launch Beigns"), 
                            ],
                            highlightColor: theme.colors.failure,
                            phase: "1"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/road.png",
                            alt: "Shadowswap",
                            className: "Shadow-road"
                        }),
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoadmapSection_StatCardContent, {
                            headingText: t(""),
                            bodyText: [
                                t("Trading, Farming, ShadowPool along with other features"),
                                t("Shadow Brigde Release"),
                                t("Partnerships with other projects"),
                                t("Shadow Treasury Setup"),
                                t("Shadows Validator Launch"), 
                            ],
                            highlightColor: theme.colors.failure,
                            phase: "2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/road.png",
                            alt: "Shadowswap",
                            className: "Shadow-road"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoadmapSection_StatCardContent, {
                            headingText: t(""),
                            bodyText: [
                                t("Shadow Governance Release with updates"),
                                t("First governance voting"),
                                t("Partnerships Updates"),
                                t("Developments Updates"),
                                t("Community Events"), 
                            ],
                            highlightColor: theme.colors.failure,
                            phase: "3"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoadmapSection = (Roadmap);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/views/Home/components/CompositeImage.tsx

function CompositeImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(",
        ", ",
        ");\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    CompositeImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompositeImage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-height: ",
        ";\n\n  & :nth-child(2) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(5) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    CompositeImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  visibility: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  img {\n    max-height: 100%;\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var floatingAnim = function(x, y) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(CompositeImage_templateObject(), x, y);
};
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-0"
})(CompositeImage_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
}, floatingAnim("3px", "15px"), floatingAnim("5px", "10px"), floatingAnim("6px", "5px"), floatingAnim("4px", "12px"));
var DummyImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dd92527b-1"
})(_templateObject2(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-2"
})(_templateObject3());
var Resolution;
(function(Resolution) {
    Resolution["MD"] = "1.5x";
    Resolution["LG"] = "2x";
})(Resolution || (Resolution = {}));
var getImageUrl = function(base, imageSrc, resolution) {
    var extension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".png";
    return "".concat(base).concat(imageSrc).concat(resolution ? "@".concat(resolution).concat(extension) : extension);
};
var getSrcSet = function(base, imageSrc) {
    var extension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".png";
    return "".concat(getImageUrl(base, imageSrc, undefined, extension), " 512w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.MD, extension), " 768w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.LG, extension), " 1024w,");
};
var CompositeImage = function(param) {
    var path = param.path, attributes = param.attributes, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "512px" : _maxHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        maxHeight: maxHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyImg, {
                srcSet: getSrcSet(path, attributes[0].src, ".webp"),
                maxHeight: maxHeight,
                loading: "lazy",
                decoding: "async",
                onError: function(e) {
                    var fallbackSrcSet = getSrcSet(path, attributes[0].src);
                    if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                        // eslint-disable-next-line no-param-reassign
                        e.currentTarget.srcset = fallbackSrcSet;
                    } else {
                        var fallbackSrc = getImageUrl(path, attributes[0].src);
                        if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.srcset = "";
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.src = fallbackSrc;
                        }
                    }
                }
            }),
            attributes.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        srcSet: getSrcSet(path, image.src, ".webp"),
                        alt: image.alt,
                        onError: function(e) {
                            var fallbackSrcSet = getSrcSet(path, image.src);
                            if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                                // eslint-disable-next-line no-param-reassign
                                e.currentTarget.srcset = fallbackSrcSet;
                            } else {
                                var fallbackSrc = getImageUrl(path, image.src);
                                if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.srcset = "";
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.src = fallbackSrc;
                                }
                            }
                        }
                    })
                }, image.src);
            })
        ]
    });
};
/* harmony default export */ var components_CompositeImage = (CompositeImage);

// EXTERNAL MODULE: ./src/views/Home/components/ColoredWordHeading.tsx
var ColoredWordHeading = __webpack_require__(51063);
;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/index.tsx






var SalesSection = function(props) {
    var headingText = props.headingText, bodyText = props.bodyText, reverse = props.reverse, primaryButton = props.primaryButton, secondaryButton = props.secondaryButton, images = props.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: [
                "column-reverse",
                null,
                null,
                reverse ? "row-reverse" : "row"
            ],
            alignItems: [
                "flex-end",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    flex: "1",
                    ml: [
                        null,
                        null,
                        null,
                        reverse && "64px"
                    ],
                    mr: [
                        null,
                        null,
                        null,
                        !reverse && "64px"
                    ],
                    alignSelf: [
                        "flex-start",
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                            text: headingText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            mb: "24px",
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    mr: "16px",
                                    children: primaryButton.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        external: true,
                                        href: primaryButton.to,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "card",
                                            bold: true,
                                            fontSize: "16px",
                                            children: primaryButton.text
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                        to: primaryButton.to,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "card",
                                            bold: true,
                                            fontSize: "16px",
                                            children: primaryButton.text
                                        })
                                    })
                                }),
                                secondaryButton.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    external: true,
                                    href: secondaryButton.to,
                                    children: secondaryButton.text
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                    to: secondaryButton.to,
                                    children: secondaryButton.text
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    height: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    width: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    flex: [
                        null,
                        null,
                        null,
                        "1"
                    ],
                    mb: [
                        "24px",
                        null,
                        null,
                        "0"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, images))
                })
            ]
        })
    });
};
/* harmony default export */ var components_SalesSection = (SalesSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Predictions.tsx
var Predictions = __webpack_require__(12448);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TicketFill.tsx
var TicketFill = __webpack_require__(57382);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(18029);
;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/PredictionCardContent.tsx

function PredictionCardContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    PredictionCardContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* NextLinkFromReactRouter */.a).withConfig({
    componentId: "sc-85d82c6b-0"
})(PredictionCardContent_templateObject());
var PredictionCardContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                mt: "48px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#280D5F",
                        bold: true,
                        fontSize: "24px",
                        children: t("ShadowPad")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#280D5F",
                        mb: "40px",
                        children: t("ShadowPad will provide a series of pre-launch support, such as IFO(Initial Farm Offering), INO(Initial NFT Offering), Farm, Pool for Projects Launching on Core BlockChain.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                    to: "/ifo",
                    id: "homepage-prediction-cta",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "invertedContrast",
                                children: t("Shadowpad")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                ml: "4px",
                                color: "invertedContrast"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var WinSection_PredictionCardContent = (PredictionCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/LotteryCardContent.tsx

function LotteryCardContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    LotteryCardContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LotteryCardContent_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* NextLinkFromReactRouter */.a).withConfig({
    componentId: "sc-581367e0-0"
})(LotteryCardContent_templateObject());
var LotteryCardContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                mt: "48px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "white",
                        bold: true,
                        fontSize: "24px",
                        children: t("Shadow Puppets NFTs")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "white",
                        mb: "40px",
                        children: t("Shadow puppets NFTs (SPN) are generated sets of 3D,unique, rare, immutable, digital Shadow figures. Which can help to grow your Defi finances and comes in limited supply, with series of utilities such as access to private IFO token sales, Staking for persive income and more utilities lurking in the shadows.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCardContent_StyledLink, {
                    to: "/shadow-puppet",
                    id: "homepage-prediction-cta",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "invertedContrast",
                                children: t("Learn More")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                ml: "4px",
                                color: "invertedContrast"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var WinSection_LotteryCardContent = (LotteryCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/index.tsx



function WinSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 16px;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  backdrop-filter: blur(12px);\n  border-radius: 72px;\n\n  ",
        " {\n    padding: 40px;\n  }\n"
    ]);
    WinSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var TransparentFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3a1fe62a-0"
})(WinSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "rgba(0, 0, 0, 0)" : " rgba(0, 0, 0, 0)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var PredictionCardData = {
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions/* default */.Z, {
        width: "60px",
        color: "inverseContrast"
    }),
    background: " linear-gradient(106.8deg, rgb(117, 255, 220) 6%, rgb(163, 216, 255) 47.6%, rgb(248, 215, 251) 87.8%);",
    borderColor: "#ffb237",
    rotation: "-2.36deg"
};
var LotteryCardData = {
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketFill/* default */.Z, {
        color: "white",
        width: "60px"
    }),
    background: " radial-gradient(263px at 100.2% 3%, rgb(12, 85, 141) 31.1%, rgb(205, 181, 93) 36.4%, rgb(244, 102, 90) 50.9%, rgb(199, 206, 187) 60.7%, rgb(249, 140, 69) 72.5%, rgb(12, 73, 116) 72.6%);",
    borderColor: "#3C1786",
    rotation: "1.43deg"
};
// const bottomLeftImage = {
//   path: '/images/home/prediction-cards/',
//   attributes: [
//     { src: 'bottom-left', alt: 'CAKE card' },
//     { src: 'green', alt: 'Green CAKE card with up arrow' },
//     { src: 'red', alt: 'Red Cake card with down arrow' },
//     { src: 'top-right', alt: 'CAKE card' },
//   ],
// }
// const topRightImage = {
//   path: '/images/home/lottery-balls/',
//   attributes: [
//     { src: '2', alt: 'Lottery ball number 2' },
//     { src: '4', alt: 'Lottery ball number 4' },
//     { src: '6', alt: 'Lottery ball number 6' },
//     { src: '7', alt: 'Lottery ball number 7' },
//     { src: '9', alt: 'Lottery ball number 9' },
//   ],
// }
var WinSection = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransparentFrame, {
            isDark: theme.isDark,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                        textAlign: "center",
                        text: t("All Products Revolves Around Shadow Token & Core in the Shadow Ecosystem")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        m: "0 auto",
                        flexDirection: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        maxWidth: "700px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flex: "1",
                                maxWidth: [
                                    "275px",
                                    null,
                                    null,
                                    "100%"
                                ],
                                mr: [
                                    null,
                                    null,
                                    null,
                                    "24px"
                                ],
                                mb: [
                                    "32px",
                                    null,
                                    null,
                                    "0"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, PredictionCardData), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WinSection_PredictionCardContent, {})
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flex: "1",
                                maxWidth: [
                                    "275px",
                                    null,
                                    null,
                                    "100%"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, LotteryCardData), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WinSection_LotteryCardContent, {})
                                }))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_WinSection = (WinSection);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SwapVert.tsx
var SwapVert = __webpack_require__(24686);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(45636);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlag.ts + 1 modules
var useFeatureFlag = __webpack_require__(20838);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var state_farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./src/utils/apr.ts + 1 modules
var apr = __webpack_require__(95347);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./packages/farms/constants/index.ts
var constants = __webpack_require__(37971);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useGetTopFarmsByApr.tsx














var useGetTopFarmsByApr = function(isIntersecting) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,hooks/* useFarms */.E2)(), farms = ref.data, regularShdwPerBlock = ref.regularShdwPerBlock;
    var ref1 = (0,react.useState)(types/* FetchStatus.Idle */.iF.Idle), fetchStatus = ref1[0], setFetchStatus = ref1[1];
    var ref2 = (0,react.useState)(false), fetched = ref2[0], setFetched = ref2[1];
    var ref3 = (0,react.useState)([
        null,
        null,
        null,
        null,
        null
    ]), topFarms = ref3[0], setTopFarms = ref3[1];
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var farmFlag = (0,useFeatureFlag/* useFeatureFlag */.y)(useFeatureFlag/* featureFarmApiAtom */.x);
    (0,react.useEffect)(function() {
        var fetchFarmData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var farmsConfig, activeFarms;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,constants.getFarmConfig)(chainId);
                        case 2:
                            farmsConfig = _ctx.sent;
                            setFetchStatus(types/* FetchStatus.Fetching */.iF.Fetching);
                            activeFarms = farmsConfig.filter(function(farm) {
                                return farm.pid !== 0;
                            });
                            _ctx.prev = 5;
                            _ctx.next = 8;
                            return dispatch((0,state_farms/* fetchFarmsPublicDataAsync */.eG)({
                                pids: activeFarms.map(function(farm) {
                                    return farm.pid;
                                }),
                                chainId: chainId,
                                flag: farmFlag
                            }));
                        case 8:
                            setFetchStatus(types/* FetchStatus.Fetched */.iF.Fetched);
                            _ctx.next = 15;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](5);
                            console.error(_ctx.t0);
                            setFetchStatus(types/* FetchStatus.Failed */.iF.Failed);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        5,
                        11
                    ]
                ]);
            }));
            return function fetchFarmData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isIntersecting && fetchStatus === types/* FetchStatus.Idle */.iF.Idle) {
            fetchFarmData();
        }
    }, [
        dispatch,
        setFetchStatus,
        fetchStatus,
        topFarms,
        isIntersecting,
        chainId,
        farmFlag
    ]);
    (0,react.useEffect)(function() {
        var getTopFarmsByApr = function(farmsState) {
            var farmsWithPrices = farmsState.filter(function(farm) {
                return farm.lpTotalInQuoteToken && farm.quoteTokenPriceBusd && farm.pid !== 0 && farm.multiplier && farm.multiplier !== "0X";
            });
            var farmsWithApr = farmsWithPrices.map(function(farm) {
                var totalLiquidity = farm.lpTotalInQuoteToken.times(farm.quoteTokenPriceBusd);
                var ref = (0,apr/* getFarmApr */.yW)(chainId, farm.poolWeight, cakePriceBusd, totalLiquidity, farm.lpAddress, regularShdwPerBlock), cakeRewardsApr = ref.cakeRewardsApr, lpRewardsApr = ref.lpRewardsApr;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                    apr: cakeRewardsApr,
                    lpRewardsApr: lpRewardsApr
                });
            });
            var sortedByApr = orderBy_default()(farmsWithApr, function(farm) {
                return farm.apr + farm.lpRewardsApr;
            }, "desc");
            setTopFarms(sortedByApr.slice(0, 5));
            setFetched(true);
        };
        if (fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched && !topFarms[0] && (farms === null || farms === void 0 ? void 0 : farms.length) > 0) {
            getTopFarmsByApr(farms);
        }
    }, [
        setTopFarms,
        farms,
        fetchStatus,
        cakePriceBusd,
        topFarms,
        regularShdwPerBlock,
        chainId
    ]);
    return {
        topFarms: topFarms,
        fetched: fetched
    };
};
/* harmony default export */ var hooks_useGetTopFarmsByApr = (useGetTopFarmsByApr);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/lodash/partition.js
var partition = __webpack_require__(43174);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);
// EXTERNAL MODULE: ./src/state/types.ts
var state_types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 6 modules
var state_pools = __webpack_require__(21557);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(83251);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var block_hooks = __webpack_require__(88770);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useGetTopPoolsByApr.tsx














var useGetTopPoolsByApr = function(isIntersecting) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,react.useState)(types/* FetchStatus.Idle */.iF.Idle), fetchStatus = ref[0], setFetchStatus = ref[1];
    var ref1 = (0,react.useState)([
        null,
        null,
        null,
        null,
        null
    ]), topPools = ref1[0], setTopPools = ref1[1];
    var initialBlock = (0,block_hooks/* useInitialBlock */.Xh)();
    var pools = (0,pools_hooks/* usePoolsWithVault */.f6)().pools;
    (0,react.useEffect)(function() {
        var fetchPoolsPublicData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setFetchStatus(types/* FetchStatus.Fetching */.iF.Fetching);
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return Promise.all([
                                dispatch((0,state_pools/* fetchCakeVaultFees */.HX)()),
                                dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)()),
                                dispatch((0,state_pools/* fetchPoolsPublicDataAsync */.ht)(initialBlock, chainId)), 
                            ]);
                        case 4:
                            setFetchStatus(types/* FetchStatus.Fetched */.iF.Fetched);
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                            setFetchStatus(types/* FetchStatus.Failed */.iF.Failed);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function fetchPoolsPublicData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isIntersecting && fetchStatus === types/* FetchStatus.Idle */.iF.Idle && initialBlock > 0) {
            fetchPoolsPublicData();
        }
    }, [
        dispatch,
        setFetchStatus,
        fetchStatus,
        topPools,
        isIntersecting,
        initialBlock,
        chainId
    ]);
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(partition_default()(pools, function(pool) {
            return pool.sousId === 0;
        }), 2), cakePools = ref[0], otherPools = ref[1];
        var masterCakePool = cakePools.filter(function(cakePool) {
            return cakePool.vaultKey === state_types/* VaultKey.CakeVault */.om.CakeVault;
        });
        var getTopPoolsByApr = function(activePools) {
            var sortedByApr = orderBy_default()(activePools, function(pool) {
                return pool.apr || 0;
            }, "desc");
            setTopPools((0,_to_consumable_array/* default */.Z)(masterCakePool).concat((0,_to_consumable_array/* default */.Z)(sortedByApr.slice(0, 4))));
        };
        if (fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched && !topPools[0]) {
            getTopPoolsByApr(otherPools);
        }
    }, [
        setTopPools,
        pools,
        fetchStatus,
        topPools
    ]);
    return {
        topPools: topPools
    };
};
/* harmony default export */ var hooks_useGetTopPoolsByApr = (useGetTopPoolsByApr);

// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(60557);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(44142);
;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/TopFarmPool.tsx

function TopFarmPool_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    TopFarmPool_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopFarmPool_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  opacity: ",
        ";\n  margin-top: ",
        ";\n  transition: opacity, margin-top, 0.4s ease-out;\n  flex-direction: column;\n\n  ",
        "\n"
    ]);
    TopFarmPool_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eae7a924-0"
})(TopFarmPool_templateObject());
var AbsoluteWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eae7a924-1"
})(TopFarmPool_templateObject1(), function(param) {
    var topOffset = param.topOffset;
    return topOffset;
}, function(param) {
    var visible = param.visible;
    return visible ? 1 : 0;
}, function(param) {
    var visible = param.visible;
    return visible ? 0 : "50%";
}, function(param) {
    var index = param.index, theme = param.theme;
    return index > 0 ? "\n         ".concat(theme.mediaQueries.sm, " {\n           height: 80px;\n           top: 0;\n           padding-left: 16px;\n           border-left: 1px ").concat(theme.colors.inputSecondary, " solid;\n         }\n       ") : "padding-right: 16px;";
});
var TopFarmPool = function(param) {
    var title = param.title, percentage = param.percentage, index = param.index, visible = param.visible, isApy = param.isApy;
    var t = (0,src/* useTranslation */.$G)().t;
    var topOffset = function() {
        if (index >= 0 && index < 2) {
            return "0px";
        }
        if (index >= 2 && index < 3) {
            return "80px";
        }
        return "160px";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        index: index,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AbsoluteWrapper, {
            index: index,
            visible: visible,
            topOffset: topOffset(),
            children: [
                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    bold: true,
                    mb: "8px",
                    fontSize: "12px",
                    color: "secondary",
                    children: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 80,
                    height: 12,
                    mb: "8px"
                }),
                percentage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                    gap: "4px",
                    children: [
                        isApy && t("Up to"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                            lineHeight: "1.1",
                            fontSize: "16px",
                            bold: true,
                            unit: "%",
                            value: percentage
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 60,
                    height: 16
                }),
                percentage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "16px",
                    color: "textSubtle",
                    children: isApy ? t("APY") : t("APR")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 30,
                    height: 16,
                    mt: "4px"
                })
            ]
        })
    });
};
/* harmony default export */ var FarmsPoolsRow_TopFarmPool = (TopFarmPool);

;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/RowHeading.tsx






var RowHeading = function(_param) {
    var text = _param.text, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text"
    ]);
    var theme = (0,useTheme/* default */.ZP)().theme;
    var split = text.split(" ");
    var firstWord = split[0];
    var remainingWords = split.slice(1).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            firstWord,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    color: theme.colors.secondary
                },
                children: [
                    " ",
                    remainingWords
                ]
            })
        ]
    }));
};
/* harmony default export */ var FarmsPoolsRow_RowHeading = (RowHeading);

;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/index.tsx

function FarmsPoolsRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n\n  ",
        " {\n    grid-gap: 16px;\n    grid-template-columns: repeat(5, auto);\n  }\n\n  ",
        " {\n    grid-gap: 32px;\n  }\n"
    ]);
    FarmsPoolsRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40045ba-0"
})(FarmsPoolsRow_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FarmsPoolsRow = function() {
    var ref = (0,react.useState)(false), showFarms = ref[0], setShowFarms = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = (0,useIntersectionObserver/* default */.Z)(), observerRef = ref1.observerRef, isIntersecting = ref1.isIntersecting;
    var ref2 = hooks_useGetTopFarmsByApr(isIntersecting), topFarms = ref2.topFarms, fetched = ref2.fetched;
    var topPools = hooks_useGetTopPoolsByApr(fetched && isIntersecting).topPools;
    var lockedApy = (0,useVaultApy/* useVaultApy */.o)().lockedApy;
    var timer = (0,react.useRef)(null);
    var isLoaded = topFarms[0] && topPools[0];
    var startTimer = (0,react.useCallback)(function() {
        timer.current = setInterval(function() {
            setShowFarms(function(prev) {
                return !prev;
            });
        }, 6000);
    }, [
        timer
    ]);
    (0,react.useEffect)(function() {
        if (isLoaded) {
            startTimer();
        }
        return function() {
            clearInterval(timer.current);
        };
    }, [
        timer,
        isLoaded,
        startTimer
    ]);
    var getPoolText = function(pool) {
        if (pool.vaultKey) {
            return pools/* vaultPoolConfig */.Y4[pool.vaultKey].name;
        }
        return t("Stake %stakingSymbol% - Earn %earningSymbol%", {
            earningSymbol: pool.earningToken.symbol,
            stakingSymbol: pool.stakingToken.symbol
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: observerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            mt: "24px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "24px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmsPoolsRow_RowHeading, {
                            text: showFarms ? t("Top Farms") : t("Top Shadow Pools")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            height: "100%",
                            width: "auto",
                            onClick: function() {
                                setShowFarms(function(prev) {
                                    return !prev;
                                });
                                clearInterval(timer.current);
                                startTimer();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapVert/* default */.Z, {
                                height: "24px",
                                width: "24px",
                                color: "textSubtle"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    height: [
                        "240px",
                        null,
                        "80px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            children: topFarms.map(function(topFarm, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FarmsPoolsRow_TopFarmPool, {
                                    title: topFarm === null || topFarm === void 0 ? void 0 : topFarm.lpSymbol,
                                    percentage: (topFarm === null || topFarm === void 0 ? void 0 : topFarm.apr) + (topFarm === null || topFarm === void 0 ? void 0 : topFarm.lpRewardsApr),
                                    index: index,
                                    visible: showFarms
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            children: topPools.map(function(topPool, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FarmsPoolsRow_TopFarmPool, {
                                    title: topPool && getPoolText(topPool),
                                    percentage: (topPool === null || topPool === void 0 ? void 0 : topPool.sousId) === 0 ? +lockedApy : topPool === null || topPool === void 0 ? void 0 : topPool.apr,
                                    index: index,
                                    isApy: (topPool === null || topPool === void 0 ? void 0 : topPool.sousId) === 0,
                                    visible: !showFarms
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_FarmsPoolsRow = (FarmsPoolsRow);

// EXTERNAL MODULE: ./src/config/abi/cake.json
var cake = __webpack_require__(93361);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(40370);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var config_constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 29 modules
var contractHelpers = __webpack_require__(18380);
;// CONCATENATED MODULE: ./src/views/Home/components/CakeDataRow.tsx




function CakeDataRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  ",
        "\n\n  ",
        "\n"
    ]);
    CakeDataRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CakeDataRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 16px 8px;\n  margin-top: 24px;\n  grid-template-columns: repeat(2, auto);\n  grid-template-areas:\n    'a d'\n    'b e'\n    'c f';\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n\n  ",
        " {\n    grid-template-areas:\n      'a b c'\n      'd e f';\n    grid-gap: 32px;\n    grid-template-columns: repeat(3, auto);\n  }\n"
    ]);
    CakeDataRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var StyledColumn = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5fdde8bb-0"
})(CakeDataRow_templateObject(), function(param) {
    var noMobileBorder = param.noMobileBorder, theme = param.theme;
    return noMobileBorder ? "".concat(theme.mediaQueries.md, " {\n           padding: 0 16px;\n           border-left: 1px ").concat(theme.colors.inputSecondary, " solid;\n         }\n       ") : "border-left: 1px ".concat(theme.colors.inputSecondary, " solid;\n         padding: 0 8px;\n         ").concat(theme.mediaQueries.sm, " {\n           padding: 0 16px;\n         }\n       ");
}, function(param) {
    var noDesktopBorder = param.noDesktopBorder, theme = param.theme;
    return noDesktopBorder && "".concat(theme.mediaQueries.md, " {\n           padding: 0;\n           border-left: none;\n         }\n       ");
});
var CakeDataRow_Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5fdde8bb-1"
})(CakeDataRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var emissionsPerBlock = 1.375;
/**
 * User (Planet Finance) built a contract on top of our original manual CAKE pool,
 * but the contract was written in such a way that when we performed the migration from Masterchef v1 to v2, the tokens were stuck.
 * These stuck tokens are forever gone (see their medium post) and can be considered out of circulation."
 * https://planetfinanceio.medium.com/pancakeswap-works-with-planet-to-help-cake-holders-f0d253b435af
 * https://twitter.com/PancakeSwap/status/1523913527626702849
 * https://bscscan.com/tx/0xd5ffea4d9925d2f79249a4ce05efd4459ed179152ea5072a2df73cd4b9e88ba7
 */ var planetFinanceBurnedTokensWei = bignumber/* BigNumber.from */.O$.from("1");
var cakeVault = (0,contractHelpers/* getCakeVaultV2Contract */.OJ)();
var CakeDataRow = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useIntersectionObserver/* default */.Z)(), observerRef = ref.observerRef, isIntersecting = ref.isIntersecting;
    var ref1 = (0,react.useState)(false), loadData = ref1[0], setLoadData = ref1[1];
    var ref2 = (0,dist/* default */.ZP)(loadData ? [
        "cakeDataRow"
    ] : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var totalSupplyCall, burnedTokenCall, ref, tokenDataResultRaw, totalLockedAmount, ref1, totalSupply, burned, totalBurned, circulating;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    totalSupplyCall = {
                        address: tokens_src/* bscTokens.cake.address */.ds.cake.address,
                        name: "totalSupply"
                    };
                    burnedTokenCall = {
                        address: tokens_src/* bscTokens.cake.address */.ds.cake.address,
                        name: "balanceOf",
                        params: [
                            "0x000000000000000000000000000000000000dead"
                        ]
                    };
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 5;
                    return Promise.all([
                        (0,multicall/* multicallv2 */.v)({
                            abi: cake,
                            calls: [
                                totalSupplyCall,
                                burnedTokenCall
                            ],
                            options: {
                                requireSuccess: false
                            }
                        }),
                        cakeVault.totalLockedAmount(), 
                    ]);
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    tokenDataResultRaw = ref[0];
                    totalLockedAmount = ref[1];
                    ref1 = (0,_sliced_to_array/* default */.Z)(tokenDataResultRaw.flat(), 2), totalSupply = ref1[0], burned = ref1[1];
                    totalBurned = planetFinanceBurnedTokensWei.add(burned);
                    circulating = totalSupply.sub(totalBurned.add(totalLockedAmount));
                    return _ctx.abrupt("return", {
                        cakeSupply: totalSupply && burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalSupply.sub(totalBurned)) : 0,
                        burnedBalance: burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalBurned) : 0,
                        circulatingSupply: circulating ? +(0,formatBalance/* formatBigNumber */.dp)(circulating) : 0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refreshInterval: config_constants/* SLOW_INTERVAL */.KI
    }), tmp = ref2.data, ref3 = tmp === void 0 ? {
        cakeSupply: 0,
        burnedBalance: 0,
        circulatingSupply: 0
    } : tmp, cakeSupply = ref3.cakeSupply, burnedBalance = ref3.burnedBalance, circulatingSupply = ref3.circulatingSupply;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var mcap = cakePriceBusd.times(circulatingSupply);
    var mcapString = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(mcap.toNumber());
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setLoadData(true);
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CakeDataRow_Grid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                style: {
                    gridArea: "a"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Circulating Supply")
                    }),
                    circulatingSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: circulatingSupply
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "b"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Total supply")
                    }),
                    cakeSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: cakeSupply
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: observerRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 24,
                                width: 126,
                                my: "4px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "c"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Max Supply")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: 100000000
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noDesktopBorder: true,
                style: {
                    gridArea: "d"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Market cap")
                    }),
                    (mcap === null || mcap === void 0 ? void 0 : mcap.gt(0)) && mcapString ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("$%marketCap%", {
                            marketCap: mcapString
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                style: {
                    gridArea: "e"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Burned to date")
                    }),
                    burnedBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: burnedBalance
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                style: {
                    gridArea: "f"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Current emissions")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("%cakeEmissions%/block", {
                            cakeEmissions: emissionsPerBlock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CakeDataRow = (CakeDataRow);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg_Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Home/components/WedgeSvgs.tsx



function WedgeSvgs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  right: 0px;\n  top: 0px;\n"
    ]);
    WedgeSvgs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WedgeSvgs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  ",
        ";\n\n  svg {\n    fill: ",
        ";\n    width: ",
        ";\n    height: 100%;\n    max-height: 48px;\n  }\n"
    ]);
    WedgeSvgs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OuterWedgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbf3a528-0"
})(WedgeSvgs_templateObject());
var InnerWedgeWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "inner-wedge"
}).withConfig({
    componentId: "sc-cbf3a528-1"
})(WedgeSvgs_templateObject1(), function(param) {
    var top = param.top;
    return top ? "top: 0px" : "bottom: 0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var width = param.width;
    return width || "100%";
});
var WedgeTopLeft = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1660 48C1139.02 46.1887 336.256 15.2453 0 0H1660V48Z"
        })
    }));
};
var WedgeTopRight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M-346 48C174.985 46.1887 977.744 15.2453 1314 0H-346V48Z"
        })
    }));
};
var WedgeBottomRight = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0 0C520.985 1.81132 1323.74 32.7547 1660 48H0V0Z"
        })
    }));
};
var WedgeBottomLeft = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1660 0C1139.02 1.81132 336.256 32.7547 0 48H1660V0Z"
        })
    }));
};

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(37291);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(87613);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(95867);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(74227);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(9919);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(69983);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lottery.png
/* harmony default export */ var lottery = ({"src":"/_next/static/media/lottery.77a09738.png","height":456,"width":2291,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42mOAgxcXOLof3jO5vXO27rWlmxtuHqgounKsxYbhztq7jCD566tvqO04dlfv4MRZzqc2rnxxZtukpafXzPMHAI1WH+57dZ/iAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFO.png
/* harmony default export */ var IFO = ({"src":"/_next/static/media/IFO.ebb90151.png","height":422,"width":582,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAwUlEQVR42mNAB956DT6ZYSs6l7V9tTnH8J+RAQRu9DFwry9gkASxNRiibL19c/5X1c79lZi8UIrh8bW9m+9fv/D2zqVTbx/dPPfmw7213gwM8lcszALvWf9jYGQACt65/+DN//sPXv97+uTl/20r5h9SYCj7X+N64W6P3VU+hkfXDl68f+vm/7vXr/1/cvfG/81LezYxMCQ8z7fd9jvPepMFw519Vbp75+dmbZqaVnJkeVEsAwMYZDNwMhQwMDAwAABx6VsysmCEywAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFOMobile.png
/* harmony default export */ var IFOMobile = ({"src":"/_next/static/media/IFOMobile.34ff4d10.png","height":346,"width":388,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA20lEQVR42mNAByE2vWaJrvPKJxQ/c7uQ8V+A4f7lI8wPH75huXrnDTMDAwNDkGO1k7FOwtuqmkX/O5t372bABnRU3Zab2xv994qL2snw9Nrm8vuXDy67eWr7hsfXDyx8c2OLGQOD61Yv5db/SfKbihge3Tz9+P79F//v33v2/+njZ/+3r5h/nJUh6X++497/re53rzI8vnHs5oO7D/4/uHPv/+N7d/+fPzC3lYGBYXGATtP/bLMt+xnuH5/hfXLzpN6Dq7qnntsxpeX//xs8DAwM0gyCDMsYGBhEAPdlan5jStVyAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competition.png
/* harmony default export */ var competition = ({"src":"/_next/static/media/competition.67316e07.png","height":426,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42mMAgXj7BYwgWkM2RrTM+2jJ7sUHTpzf2/KgPGTiKgY0wFQcvDZ+Tsfig0eXlT/qKO+qAgBSTBTvrbglSwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competitionMobile.png
/* harmony default export */ var competitionMobile = ({"src":"/_next/static/media/competitionMobile.48f2da21.png","height":364,"width":676,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAcUlEQVR42mOAgRdnahlh7JdXGa7ePOF+MEIyZypY4NOJmWDJ/9cmczzbPz3/4fk57w8ujLswLa/qP1jBtg2zmUD0+u0zlPctXvD/+O6z69dN2FK1c+bR/www8HtzDFjRjmD2nicnGDavnNt+KTdg2TMA6TQzLcAU8r8AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-desktop.png
/* harmony default export */ var mod_tc_desktop = ({"src":"/_next/static/media/mod-tc-desktop.e1700017.png","height":677,"width":1290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAgElEQVR42mNABld76/j+H9nKDuP/v/KfleHQ9lvCcQxZbEAu4+rIgMSFURGT/hsxiN05d1/z4fnXzQyLp+w1WlC4JH9Rw9olweGe81Iry64saMk9vDAvuvnfz/9yDFNWfmKdlTO7oa26tTeuJGOa67TedRXdzTEH0qwnnl2+kwcATX44UG7gXEAAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-mobile.png
/* harmony default export */ var mod_tc_mobile = ({"src":"/_next/static/media/mod-tc-mobile.92900d89.png","height":403,"width":412,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA6UlEQVR42mNABmfbJzBvZ2BgfLfkP+vz4+/Cn+x+IwOWKA9czrirZioTTOGJA1e73979/P/9ie/ZKCZcac42v92eHbZ10cask3tvTft/+78ASJyxzXeSGgPDf6YFETGTliQl/0/Vj3FH0Tkpdc6MqcXrp9Ta+dfOjLL935SdvOJYXfTux6U6ixg2F22WXVa2/P22efsvRpmalGXbGrwqbm/uak7w/3+wO7AabEKObvj2iriKh46l+f9bMqL+b6lI+V+elfA/f9MaY7CCDiM7+d45E9YlVBTMmpoftvxsnsmmgwFiVccYGHgAZVpmxlmVVcEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lotteryMobile.png
/* harmony default export */ var lotteryMobile = ({"src":"/_next/static/media/lotteryMobile.7ad41ede.png","height":278,"width":376,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAA0UlEQVR4nAHGADn/AcLP/wEIAPT/EPbjIu/e8wI2VMbc/QYHFuzm2YX49ODzAc2/2QACAf8xBQUGIgfs1mX02PLSEEwOjvzrr+f5/+XVAZa8/w495529CvPkw/oJF0gDEQX+6ggUwgkAe2kOChTvAZqm2Swn3LK3DSAQGv4hHfsKB+IH1ckemC0rkxsSEyDXAbCiyib56AAgCS3uePUF+Ska4+t/0N8h4jMo73QJAPwOAcq21jnl6fDd4LSrBPkbIBUyRw/R6eclQg/z4wEmBdflwCZgu7ev0Q0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-white-logo.png
/* harmony default export */ var mod_white_logo = ({"src":"/_next/static/media/mod-white-logo.02856f5f.png","height":134,"width":489,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALElEQVR42mP4J/NP55/6P+1/pv8M/un+E2L4F/6v7l/Gv9R/5f9K/9X88wcAT/wUeIPmTSsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetual.png
/* harmony default export */ var perpetual = ({"src":"/_next/static/media/perpetual.444db937.png","height":464,"width":784,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAfklEQVR42mMAARv3FEYQHdN+iD8+bZEAiG0WVsEIkfQIY2YAg0CTstzQlxW5vm9BwiARW0M9ZgZdcx+IAmUvIztH9/8VgTb/661YLUBCNa6aEDk383BGEK2qZney2Fr3IgMYgMQQgNEpqs+UwTDoeoebyN1TWUaaIMEzOYaMAFiKHjG1WRaWAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetualMobile.png
/* harmony default export */ var perpetualMobile = ({"src":"/_next/static/media/perpetualMobile.fc934da7.png","height":416,"width":384,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAsElEQVR42mNQtgphZMAChBhYIOI+SdXy3mEpteWVrbv97GyaPE1NVeGq5K2ClyeFW/5fNyPsf3G6w381IfWdcEl1fadKTS2j/4nR3l9CrXT/J5oqtsIl7d1TrDj1fP5720X9mhZo9n9PspITWELbq5QZzFBzOhJmZvS/yYH3HJDHfKzEA8mh8qZTzNU0/9fZcC2Fi6mZxzoahbbP1XPN/gbU8H9rov6vXYlaE9QYGJQAvAQ1RtWHoZ4AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/listing.png
/* harmony default export */ var listing = ({"src":"/_next/static/media/listing.d5240f76.png","height":464,"width":784,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAjElEQVR42mMAAbvernDHqRMLGaBALSZKRS8vW4ABBhwm9Zu5zZv1zryh1hOo0MKyueGmSVV5JAMIeMyexQyiLZrq1wEV/XebP/u/94olIDqYAQTK/v9nBNEus6dt912z4r/n4vn/3RfO/e8+f3Y4AxJgK8zbdT+7YPM9i5ndMz3mz1lu29OpxsDAwAAAodI1wpUe5TkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/listingMobile.png
/* harmony default export */ var listingMobile = ({"src":"/_next/static/media/listingMobile.cfb08372.png","height":208,"width":192,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA4UlEQVR42mMQMNCzYgAC1zkzmBmAQL8gl4kBBtzmzfpv29PhywAEaQ9ugyUMSwo1TKrK3Rlc58586jJ7+j2gGCMQczMAgV5u9nzj8pL/DPYTeoqBCv7b9XU9BBr9EKjwPhB/dJk17T+Dtm0Qr0Fe7kWvpYv+u8+f/d9l9oz/PquW/fdbv+ofAxAIWs/oeeyybM5/v41rfnosmv/bcerE357LFv5ncPEtr0lYvft/3OJt/90mTvnvtmjOf/cFc/57LgVKhim2e9SpHvxaw7P3vkVmUabD9ImJzlMnZZjX13gAAGf/YE+hbJOvAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/index.ts















;// CONCATENATED MODULE: ./src/views/Home/components/Banners/Styled.tsx

function Styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: -webkit-linear-gradient(#ffd800, #eb8c00);\n  font-size: 20px;\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 1px rgba(0, 0, 0, 0.5);\n  ",
        " {\n    font-size: 24px;\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    Styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ffffff;\n  background: -webkit-linear-gradient(#7645d9 0%, #452a7a 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-stroke: 6px transparent;\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  ",
        " {\n    margin-bottom: 16px;\n  }\n"
    ]);
    Styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 32px;\n  width: 100%;\n  max-height: max-content;\n  overflow: visible;\n  ",
        " {\n    overflow: visible;\n  }\n"
    ]);
    Styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 24px;\n  flex-direction: row;\n  justify-content: space-between;\n  max-height: 192px;\n"
    ]);
    Styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  ",
        " {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -17px;\n  opacity: 0.9;\n  transform: translate(0, -50%);\n  top: 50%;\n\n  img {\n    height: 100%;\n    width: 500px;\n  }\n\n  ",
        " {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    right: 24px;\n    bottom: 0;\n    transform: unset;\n    opacity: 1;\n    top: unset;\n    height: 211px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-0"
})(Styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-1"
})(Styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Styled_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-2"
})(Styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-3"
})(Styled_templateObject3());
var LeftWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/CompetitionBanner.tsx

function CompetitionBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -7px;\n  ",
        " {\n    bottom: 0px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -30px;\n  }\n"
    ]);
    CompetitionBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    CompetitionBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: 10px 0 0 4px;\n  align-self: center;\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    CompetitionBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CompetitionBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c0c67f9f-0"
})(CompetitionBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-c0c67f9f-1"
})(CompetitionBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TradingCompetition = (0,styled_components_browser_esm/* default */.ZP)(StyledSubheading).withConfig({
    componentId: "sc-c0c67f9f-2"
})(CompetitionBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CompetitionBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: mod_white_logo,
                                    alt: "ModLogo",
                                    width: isMobile ? "68px" : "112px",
                                    height: isMobile ? "18px" : "33px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingCompetition, {
                                    children: t("Trading Competition")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                            width: [
                                "150px",
                                "150px",
                                "auto"
                            ],
                            children: t("$120,000 in Prizes!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/competition",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Trade Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_desktop,
                        alt: "CompetitionBanner",
                        width: 632,
                        height: 338,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_mobile,
                        alt: "CompetitionBanner",
                        width: 206,
                        height: 201,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_CompetitionBanner = (/*#__PURE__*/(0,react.memo)(CompetitionBanner));

// EXTERNAL MODULE: ./src/hooks/useActiveIfoWithBlocks.ts
var useActiveIfoWithBlocks = __webpack_require__(73839);
// EXTERNAL MODULE: ./src/views/Ifos/hooks/helpers.ts
var helpers = __webpack_require__(81379);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/IFOBanner.tsx

function IFOBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {transform:translateX(-100%);}\n  20% {transform:translateX(100%);}\n	100% {transform:translateX(100%);}\n"
    ]);
    IFOBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 1px;\n  bottom: 18px;\n  ",
        " {\n    bottom: -3px;\n    right: 0;\n  }\n  ",
        " {\n    bottom: 9px;\n    right: 67px;\n  }\n  ",
        " {\n    bottom: -3px;\n    right: 67px;\n  }\n  z-index: 0;\n"
    ]);
    IFOBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-image: ",
        ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 35px;\n  height: 35px;\n  bottom: 35px;\n  right: 95px;\n  overflow: hidden;\n  border-radius: 50%;\n  z-index: 2;\n  ",
        " {\n    width: 60px;\n    height: 60px;\n    bottom: 25px;\n    right: 196px;\n    z-index: 2;\n  }\n  &::after {\n    content: '';\n    top: 0;\n    transform: translateX(100%);\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    animation: ",
        " 5s infinite 1s;\n    background: -webkit-linear-gradient(\n      left,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.8) 50%,\n      rgba(128, 186, 232, 0) 99%,\n      rgba(125, 185, 232, 0) 100%\n    );\n  }\n"
    ]);
    IFOBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var IFOHeaderMobileLimitHeight = 36;
var IFOHeaderMobileLimitWidth = 335;
var shineAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(IFOBanner_templateObject());
var IFOBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad27aa0d-0"
})(IFOBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var IFOIconImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad27aa0d-1"
})(IFOBanner_templateObject2(), function(param) {
    var src = param.src;
    return 'url("'.concat(src, '")');
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, shineAnimation);
var IFOBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var headingRef = (0,react.useRef)(null);
    var currentBlock = (0,block_hooks/* useCurrentBlock */.je)();
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    var ref;
    var ifoName = (ref = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.name) !== null && ref !== void 0 ? ref : "XXX";
    var isIfoAlive = !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
    var status = isIfoAlive ? (0,helpers/* getStatus */.l)(currentBlock, activeIfoWithBlocks.startBlock, activeIfoWithBlocks.endBlock) : null;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,react.useEffect)(function() {
        if (!headingRef.current) return;
        if (!isMobile) headingRef.current.style.fontSize = "";
        else if (headingRef.current.offsetHeight > IFOHeaderMobileLimitHeight || headingRef.current.offsetWidth > IFOHeaderMobileLimitWidth) {
            headingRef.current.style.fontSize = "20px";
        }
    }, [
        isMobile
    ]);
    var ref1, ref2;
    return isIfoAlive && status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            children: status === "live" ? t("Live") : t("Soon")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeading, {
                            scale: "xl",
                            ref: headingRef,
                            children: [
                                ifoName,
                                " ",
                                t("IFO")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/ifo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Go to IFO")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IFOBanner_RightWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IFOIconImage, {
                            src: "/images/tokens/".concat(activeIfoWithBlocks.token.address, ".png"),
                            onError: function(event) {
                                // @ts-ignore
                                // eslint-disable-next-line no-param-reassign
                                event.target.style.display = "none";
                            }
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFO,
                            alt: "IFO ".concat((ref1 = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && ref1 !== void 0 ? ref1 : "XXX"),
                            width: 291,
                            height: 211,
                            placeholder: "blur"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFOMobile,
                            alt: "IFO ".concat((ref2 = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && ref2 !== void 0 ? ref2 : "XXX"),
                            width: 150,
                            height: 150,
                            placeholder: "blur"
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var Banners_IFOBanner = (/*#__PURE__*/(0,react.memo)(IFOBanner));

// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber_js_bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber_js_bignumber);
// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(13471);
;// CONCATENATED MODULE: ./src/views/Lottery/components/Countdown/Timer.tsx

function Timer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  div:last-of-type {\n    margin-right: 0;\n  }\n"
    ]);
    Timer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Timer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n"
    ]);
    Timer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledTimerFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a9e55172-0"
})(Timer_templateObject(), function(param) {
    var theme = param.theme, showTooltip = param.showTooltip;
    return showTooltip ? " border-bottom: 1px dashed ".concat(theme.colors.textSubtle, ";") : "";
});
var StyledTimerText = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-a9e55172-1"
})(Timer_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientGold;
});
var Timer_Wrapper = function(param) {
    var minutes = param.minutes, hours = param.hours, days = param.days, seconds = param.seconds, wrapperClassName = param.wrapperClassName;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimerFlex, {
        alignItems: "flex-end",
        className: wrapperClassName,
        children: [
            Boolean(days) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: days
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("d")
                    })
                ]
            }),
            Boolean(hours) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: hours
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("h")
                    })
                ]
            }),
            Boolean(minutes) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: minutes
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("m")
                    })
                ]
            }),
            Boolean(seconds) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: seconds
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("s")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Timer = (Timer_Wrapper);

;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useGetNextLotteryEvent.ts



var vrfRequestTime = 180 // 3 mins
;
var secondsBetweenRounds = 300 // 5 mins
;
var transactionResolvingBuffer = 30 // Delay countdown by 30s to ensure contract transactions have been calculated and broadcast
;
var useGetNextLotteryEvent = function(endTime, status) {
    var t = (0,src/* useTranslation */.$G)().t;
    return (0,react.useMemo)(function() {
        // Current lottery is active
        if (status === types/* LotteryStatus.OPEN */.p3.OPEN) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer,
                preCountdownText: null,
                postCountdownText: t("until the draw")
            };
        }
        // Current lottery has finished but not yet claimable
        if (status === types/* LotteryStatus.CLOSE */.p3.CLOSE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + vrfRequestTime,
                preCountdownText: t("Winners announced in"),
                postCountdownText: null
            };
        }
        // Current lottery claimable. Next lottery has not yet started
        if (status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + secondsBetweenRounds,
                preCountdownText: t("Tickets on sale in"),
                postCountdownText: null
            };
        }
        return {
            nextEventTime: null,
            preCountdownText: null,
            postCountdownText: null
        };
    }, [
        endTime,
        status,
        t
    ]);
};
/* harmony default export */ var hooks_useGetNextLotteryEvent = (useGetNextLotteryEvent);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useNextEventCountdown.ts

var useNextEventCountdown = function(nextEventTime) {
    var ref = (0,react.useState)(null), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var timer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var currentSeconds = Math.floor(Date.now() / 1000);
        var secondsRemainingCalc = Math.max(nextEventTime - currentSeconds, 0);
        setSecondsRemaining(secondsRemainingCalc);
        timer.current = setInterval(function() {
            setSecondsRemaining(function(prevSecondsRemaining) {
                return Math.max(prevSecondsRemaining - 1, 0);
            });
        }, 1000);
        return function() {
            return clearInterval(timer.current);
        };
    }, [
        nextEventTime
    ]);
    return secondsRemaining;
};
/* harmony default export */ var hooks_useNextEventCountdown = (useNextEventCountdown);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/LotteryBanner.tsx

function LotteryBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -8px;\n  ",
        " {\n    right: 1px;\n    bottom: 1px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: 8px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: -5px;\n  }\n"
    ]);
    LotteryBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: 16px;\n  }\n  margin-bottom: 8px;\n  .custom-timer {\n    background: url('/images/decorations/countdownBg.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    padding: 0px 10px 7px;\n    display: inline-flex;\n    white-space: nowrap;\n    transform: scale(0.88);\n    transform-origin: top left;\n  }\n"
    ]);
    LotteryBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: white;\n  ",
        " {\n    font-size: 24px;\n    &.lottery {\n      font-size: 20px;\n    }\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    LotteryBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var LotteryBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-410a0169-0"
})(LotteryBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var TimerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-410a0169-1"
})(LotteryBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LotteryBanner_StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-410a0169-2"
})(LotteryBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var isLotteryLive = function(status) {
    return status === types/* LotteryStatus.OPEN */.p3.OPEN;
};
var LotteryPrice = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var prizeInBusd = new (bignumber_default())(data.amountCollectedInCake).times(cakePriceBusd);
    var prizeTotal = (0,formatBalance/* getBalanceNumber */.mW)(prizeInBusd);
    var t = (0,src/* useTranslation */.$G)().t;
    if (isLotteryLive(data.status)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                height: 20,
                width: 90,
                display: "inline-block"
            }) : t("Win $%prize% in Lottery", {
                prize: prizeTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })
            })
        });
    }
    return null;
};
var LotteryCountDownTimer = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var endTimeAsInt = parseInt(data.endTime, 10);
    var nextEventTime = hooks_useGetNextLotteryEvent(endTimeAsInt, data.status).nextEventTime;
    var secondsRemaining = hooks_useNextEventCountdown(nextEventTime);
    var ref = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = ref.days, hours = ref.hours, minutes = ref.minutes, seconds = ref.seconds;
    if (isLotteryLive(data.status)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer, {
        wrapperClassName: "custom-timer",
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    });
    return null;
};
var LotteryBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var ref = (0,dist/* default */.ZP)([
        "currentLottery"
    ]), data = ref.data, status = ref.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        status === types/* FetchStatus.Fetched */.iF.Fetched && isLotteryLive(data.status) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_StyledSubheading, {
                                    className: "lottery",
                                    style: {
                                        textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPrice, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCountDownTimer, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                                    children: t("Lottery")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                                    scale: "xl",
                                    children: t("Preparing")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/lottery",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: status === types/* FetchStatus.Fetched */.iF.Fetched && isLotteryLive(data.status) ? t("Play Now") : t("Check Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: lottery,
                        alt: "LotteryBanner",
                        width: 1112,
                        height: 192 + 32,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mobile",
                        src: lotteryMobile,
                        alt: "LotteryBanner",
                        width: 190,
                        height: 144,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_LotteryBanner = (/*#__PURE__*/(0,react.memo)(LotteryBanner));

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/ListingFPBanner.tsx

function ListingFPBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-height: 100%;\n  right: 0;\n  bottom: 0px;\n  ",
        " {\n    bottom: 8.2px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -2px;\n  }\n"
    ]);
    ListingFPBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListingFPBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  min-height: 44px;\n  ",
        " {\n    font-size: 40px;\n    min-height: auto;\n  }\n"
    ]);
    ListingFPBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var ListingFPBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d866a9fd-0"
})(ListingFPBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var ListingFPBanner_Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-d866a9fd-1"
})(ListingFPBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var HEADING_ONE_LINE_HEIGHT = 27;
var PerpetualBanner = function() {
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, code = ref.currentLanguage.code;
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var headerRef = (0,react.useRef)(null);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var target = headerRef.current;
        target.style.fontSize = "" // reset
        ;
        target.style.lineHeight = "";
        if (!target || !isMobile) return;
        if (target.offsetHeight > HEADING_ONE_LINE_HEIGHT) {
            target.style.fontSize = "18px";
            target.style.lineHeight = "".concat(HEADING_ONE_LINE_HEIGHT, "px");
        }
    }, [
        isMobile,
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            ref: headerRef,
                            children: t("Listing")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingFPBanner_Header, {
                            width: [
                                "160px",
                                "160px",
                                "auto"
                            ],
                            children: t("Apply For Partnership")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "https://docs.google.com/forms/d/e/1FAIpQLSevsQylnWNYeYYA-JXd7j3DDxhuZV_HibW-iTSXt51JkualyA/viewform?vc=0&c=0&w=1&flr=0",
                            external: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Apply Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingFPBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: listing,
                        alt: "FarmlistingBanner",
                        width: 392,
                        height: 232,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: listingMobile,
                        alt: "FarmlistingBanner",
                        width: 208,
                        height: 208,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ListingFPBanner = (/*#__PURE__*/(0,react.memo)(PerpetualBanner));

;// CONCATENATED MODULE: ./src/utils/getPerpetualLanguageCode.ts
var perpetualLangs = {
    en: "en",
    ko: "ko",
    ja: "ja",
    de: "de",
    fr: "fr",
    id: "id",
    tr: "tr",
    hi: "hi",
    ru: "ru",
    vi: "vi",
    pl: "pl",
    uk: "uk-UA",
    "es-ES": "es",
    "zh-cn": "zh-CN",
    "pt-br": "pt-BR"
};
var perpLangMap = function(languageCode) {
    if (!languageCode) {
        return "en";
    }
    if (perpetualLangs[languageCode]) {
        return perpetualLangs[languageCode];
    }
    return "en";
};

;// CONCATENATED MODULE: ./src/utils/getPerpetualTheme.ts
var perpTheme = function(isDark) {
    return isDark ? "dark" : "light";
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/PerpetualBanner.tsx

function PerpetualBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-height: 100%;\n  right: 0;\n  bottom: 0px;\n  ",
        " {\n    bottom: 8.2px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -2px;\n  }\n"
    ]);
    PerpetualBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerpetualBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  min-height: 44px;\n  ",
        " {\n    font-size: 40px;\n    min-height: auto;\n  }\n"
    ]);
    PerpetualBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var PerpetualBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41795ddd-0"
})(PerpetualBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PerpetualBanner_Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-41795ddd-1"
})(PerpetualBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var PerpetualBanner_HEADING_ONE_LINE_HEIGHT = 27;
var PerpetualBanner_PerpetualBanner = function() {
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, code = ref.currentLanguage.code;
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var isDark = (0,styled_components_browser_esm/* useTheme */.Fg)().isDark;
    var perpetualUrl = (0,react.useMemo)(function() {
        return "https://docs.shadowswap.xyz/".concat(perpLangMap(code), "/the-team/sverse-lab?theme=").concat(perpTheme(isDark));
    }, [
        code,
        isDark
    ]);
    var headerRef = (0,react.useRef)(null);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var target = headerRef.current;
        target.style.fontSize = "" // reset
        ;
        target.style.lineHeight = "";
        if (!target || !isMobile) return;
        if (target.offsetHeight > PerpetualBanner_HEADING_ONE_LINE_HEIGHT) {
            target.style.fontSize = "18px";
            target.style.lineHeight = "".concat(PerpetualBanner_HEADING_ONE_LINE_HEIGHT, "px");
        }
    }, [
        isMobile,
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            ref: headerRef,
                            children: t("SVerse Lab")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_Header, {
                            width: [
                                "160px",
                                "160px",
                                "auto"
                            ],
                            children: t("Powered by SVerse Lab")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: perpetualUrl,
                            external: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Learn More Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: perpetual,
                        alt: "PerpetualBanner",
                        width: 392,
                        height: 232,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: perpetualMobile,
                        alt: "PerpetualBanner",
                        width: 208,
                        height: 208,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_PerpetualBanner = (/*#__PURE__*/(0,react.memo)(PerpetualBanner_PerpetualBanner));

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderIFOBanner.tsx


var useIsRenderIfoBanner = function() {
    var currentBlock = (0,block_hooks/* useCurrentBlock */.je)();
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    return !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
};
/* harmony default export */ var useIsRenderIFOBanner = (useIsRenderIfoBanner);

// EXTERNAL MODULE: ./src/state/lottery/helpers.ts
var lottery_helpers = __webpack_require__(72551);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderLotteryBanner.tsx







var useIsRenderLotteryBanner = function() {
    var ref = (0,dist/* default */.ZP)([
        "currentLotteryId"
    ], lottery_helpers/* fetchCurrentLotteryId */.kC, {
        refreshInterval: config_constants/* SLOW_INTERVAL */.KI,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryId = ref.data, currentLotteryIdStatus = ref.status;
    var ref1 = (0,dist/* default */.ZP)(currentLotteryId ? [
        "currentLottery"
    ] : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,lottery_helpers/* fetchLottery */.JE)(currentLotteryId.toString()));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        refreshInterval: config_constants/* FAST_INTERVAL */.sR,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryStatus = ref1.status;
    return currentLotteryIdStatus === types/* FetchStatus.Fetched */.iF.Fetched && currentLotteryStatus === types/* FetchStatus.Fetched */.iF.Fetched;
};
/* harmony default export */ var hooks_useIsRenderLotteryBanner = (useIsRenderLotteryBanner);

// EXTERNAL MODULE: ./src/components/Menu/hooks/useCompetitionStatus.ts + 1 modules
var useCompetitionStatus = __webpack_require__(15690);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderCompetitionBanner.tsx

var useIsRenderCompetitionBanner = function() {
    var competitionStatus = (0,useCompetitionStatus/* useCompetitionStatus */.U)();
    return competitionStatus !== null;
};
/* harmony default export */ var hooks_useIsRenderCompetitionBanner = (useIsRenderCompetitionBanner);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useMultipleBannerConfig.tsx












/**
 * make your custom hook to control should render specific banner or not
 * add new campaign banner easily
 *
 * @example
 * ```ts
 *  {
 *    shouldRender: isRenderIFOBanner,
 *    banner: <IFOBanner />,
 *  },
 * ```
 */ var useMultipleBannerConfig = function() {
    var isRenderIFOBanner = useIsRenderIFOBanner();
    var isRenderLotteryBanner = hooks_useIsRenderLotteryBanner();
    var isRenderCompetitionBanner = hooks_useIsRenderCompetitionBanner();
    return (0,react.useMemo)(function() {
        var NO_SHUFFLE_BANNERS = [
            {
                shouldRender: isRenderIFOBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_IFOBanner, {})
            }, 
        ];
        var SHUFFLE_BANNERS = [
            {
                shouldRender: isRenderCompetitionBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_CompetitionBanner, {})
            },
            {
                shouldRender: isRenderLotteryBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_LotteryBanner, {})
            },
            {
                shouldRender: true,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_PerpetualBanner, {})
            },
            {
                shouldRender: true,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingFPBanner, {})
            }, 
        ];
        return (0,_to_consumable_array/* default */.Z)(NO_SHUFFLE_BANNERS).concat((0,_to_consumable_array/* default */.Z)(shuffle_default()(SHUFFLE_BANNERS))).filter(function(bannerConfig) {
            return bannerConfig.shouldRender;
        }).map(function(bannerConfig) {
            return bannerConfig.banner;
        });
    }, [
        isRenderIFOBanner,
        isRenderLotteryBanner,
        isRenderCompetitionBanner
    ]);
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/MultipleBanner.tsx

function MultipleBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 179px;\n  ",
        " {\n    height: 221px;\n  }\n  ",
        " {\n    height: 232px;\n  }\n  &::before {\n    content: '';\n    border-radius: 32px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background: -webkit-linear-gradient(#7645d9 0%, #452a7a 100%);\n    ",
        " {\n      top: 20px;\n      left: 20px;\n      right: 20px;\n      bottom: 20px;\n    }\n  }\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: 30px;\n  }\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n  ",
        ",",
        " {\n    padding-top: 0;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MultipleBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultipleBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: visible;\n  opacity: 0;\n  animation: ",
        " 0.3s ease-in-out 0.7s forwards;\n  .swiper-pagination {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    width: 108px;\n    bottom: 12px;\n    ",
        " {\n      bottom: 35px;\n    }\n    ",
        " {\n      bottom: 45px;\n    }\n    ",
        " {\n      bottom: 35px;\n    }\n  }\n  .swiper-pagination-bullet {\n    background-color: white;\n    flex-basis: 108px;\n    margin: 0 !important;\n    border-radius: 0px;\n    &:first-child {\n      border-radius: 4px 0px 0px 4px;\n    }\n    &:last-child {\n      border-radius: 0px 4px 4px 0px;\n    }\n  }\n"
    ]);
    MultipleBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var BannerPlaceHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-175c111c-0"
})(MultipleBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "250px" : "0px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "-220px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "190px" : "-32px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "90px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "40px" : "30px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "30px";
});
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-175c111c-1"
})(MultipleBanner_templateObject1(), animationToolkit/* appearAnimation */.Oz, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var MultipleBanner = function() {
    var bannerList = useMultipleBannerConfig();
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref.isDesktop, isTablet = ref.isTablet;
    var ref1 = (0,react.useState)(null), swiperRef = ref1[0], setSwiperRef = ref1[1];
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        if (swiperRef) {
            var ref, ref1;
            if (bannerList.length > 1 && !((ref = swiperRef.autoplay) === null || ref === void 0 ? void 0 : ref.running)) {
                var ref2;
                (ref2 = swiperRef.autoplay) === null || ref2 === void 0 ? void 0 : ref2.start();
            } else if (bannerList.length <= 1 && ((ref1 = swiperRef.autoplay) === null || ref1 === void 0 ? void 0 : ref1.running)) {
                var ref3;
                (ref3 = swiperRef.autoplay) === null || ref3 === void 0 ? void 0 : ref3.stop();
            }
        }
    }, [
        bannerList,
        swiperRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerPlaceHolder, {
        walletConnected: Boolean(account),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
            onSwiper: setSwiperRef,
            modules: [
                swiper_esm/* Autoplay */.pt,
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW
            ],
            spaceBetween: 50,
            observer: true,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            speed: 500,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            loop: true,
            pagination: {
                clickable: true
            },
            children: bannerList.map(function(banner, index) {
                var childKey = "Banner".concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        padding: isDesktop || isTablet ? 20 : 0
                    },
                    children: banner
                }, childKey);
            })
        })
    });
};
/* harmony default export */ var Banners_MultipleBanner = (MultipleBanner);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx


function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















// import UserBanner from './components/UserBanner'

var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-9d196600-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
// const UserBannerWrapper = styled(Container)`
//   z-index: 1;
//   position: absolute;
//   width: 100%;
//   top: 0;
//   left: 50%;
//   transform: translate(-50%, 0);
//   padding-left: 0px;
//   padding-right: 0px;
//   ${({ theme }) => theme.mediaQueries.lg} {
//     padding-left: 24px;
//     padding-right: 24px;
//   }
// `
var Home = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    // const { account } = useWeb3React()
    // const { chainId } = useActiveChainId()
    var HomeSectionContainerStyles = {
        margin: "0",
        width: "100%",
        maxWidth: "968px"
    };
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "6161ba694a5f0b4b",
                children: '#home-1 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/coneback.png");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}[data-theme="dark"] #home-1 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/coneback.png");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}@media(max-width:767px){#home-1 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/mobile-background.png");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}}#home-2 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#9370db 100%);background:-moz-linear-gradient(top,#09070c 22%,#9370db 100%);background:-o-linear-gradient(top,#09070c 22%,#9370db 100%);background:linear-gradient(180deg,#09070c 22%,#9370db 100%)}[data-theme="dark"] #home-2 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#9370db 100%);background:-moz-linear-gradient(top,#09070c 22%,#9370db 100%);background:-o-linear-gradient(top,#09070c 22%,#9370db 100%);background:linear-gradient(180deg,#09070c 22%,#9370db 100%)}#home-3 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/Box.jpg");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}[data-theme="dark"] #home-3 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/Box.jpg");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}@media(max-width:767px){#home-3 .page-bg{background:url("https://raw.githubusercontent.com/SVerseLab/images/master/mobile-background.png");-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;background-position:center;background-width:100%;background-height:100vh}}#home-4 .inner-wedge svg{fill:#9370db}[data-theme="dark"] #home-4 .inner-wedge svg{fill:#9370db}#home-5 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#000 100%);background:-moz-linear-gradient(top,#09070c 22%,#000 100%);background:-o-linear-gradient(top,#09070c 22%,#000 100%);background:linear-gradient(180deg,#09070c 22%,#000 100%)}[data-theme="dark"] #home-5 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#000 100%);background:-moz-linear-gradient(top,#09070c 22%,#000 100%);background:-o-linear-gradient(top,#09070c 22%,#000 100%);background:linear-gradient(180deg,#09070c 22%,#000 100%)}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-1"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_MultipleBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-2"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                containerProps: {
                    id: "home-4"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWedgeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWedgeWrapper, {
                            top: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WedgeTopLeft, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, swapSectionData(t)))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, nftammSectionData(t)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-5"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoadmapSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.gradientCardHeader,
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWedgeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWedgeWrapper, {
                            width: "150%",
                            top: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WedgeTopRight, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, earnSectionData(t))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FarmsPoolsRow, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                containerProps: {
                    id: "home-3"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WinSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, cakeSectionData(t))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CakeDataRow, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 83251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xo": function() { return /* binding */ useCakeVault; },
  "Es": function() { return /* binding */ useCakeVaultUserData; },
  "YX": function() { return /* binding */ useDeserializedPoolByVaultKey; },
  "FM": function() { return /* binding */ useFetchIfo; },
  "dd": function() { return /* binding */ useIfoCeiling; },
  "cq": function() { return /* binding */ useIfoCredit; },
  "AI": function() { return /* binding */ usePool; },
  "l7": function() { return /* binding */ usePoolsPageFetch; },
  "f6": function() { return /* binding */ usePoolsWithVault; },
  "eB": function() { return /* binding */ useVaultPoolByKey; }
});

// UNUSED EXPORTS: useFetchPublicPoolsData

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(33533);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlag.ts + 1 modules
var useFeatureFlag = __webpack_require__(20838);
// EXTERNAL MODULE: ./packages/farms/constants/index.ts
var constants = __webpack_require__(37971);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 6 modules
var state_pools = __webpack_require__(21557);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(96470);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/pools/helpers.ts
var helpers = __webpack_require__(12831);
// EXTERNAL MODULE: ./src/utils/cakePool.ts
var utils_cakePool = __webpack_require__(23702);
;// CONCATENATED MODULE: ./src/state/pools/selectors.ts










var selectPoolsData = function(state) {
    return state.pools.data;
};
var selectPoolData = function(sousId) {
    return function(state) {
        return state.pools.data.find(function(p) {
            return p.sousId === sousId;
        });
    };
};
var selectUserDataLoaded = function(state) {
    return state.pools.userDataLoaded;
};
var selectVault = function(key) {
    return function(state) {
        return key ? state.pools[key] : state_pools/* initialPoolVaultState */.XW;
    };
};
var selectIfo = function(state) {
    return state.pools.ifo;
};
var _credit;
var selectIfoUserCredit = function(state) {
    return (_credit = state.pools.ifo.credit) !== null && _credit !== void 0 ? _credit : bigNumber/* BIG_ZERO */.HW;
};
var makePoolWithUserDataLoadingSelector = function(sousId) {
    return (0,reselect_es/* createSelector */.P1)([
        selectPoolData(sousId),
        selectUserDataLoaded
    ], function(pool, userDataLoaded) {
        return {
            pool: (0,helpers/* transformPool */.xK)(pool),
            userDataLoaded: userDataLoaded
        };
    });
};
var poolsWithUserDataLoadingSelector = (0,reselect_es/* createSelector */.P1)([
    selectPoolsData,
    selectUserDataLoaded
], function(pools, userDataLoaded) {
    return {
        pools: pools.map(helpers/* transformPool */.xK),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolByKey = function(key) {
    return (0,reselect_es/* createSelector */.P1)([
        selectVault(key)
    ], function(vault) {
        return (0,helpers/* transformVault */.LJ)(key, vault);
    });
};
var poolsWithVaultSelector = (0,reselect_es/* createSelector */.P1)([
    poolsWithUserDataLoadingSelector,
    makeVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault),
    makeVaultPoolByKey(types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault), 
], function(poolsWithUserDataLoading, deserializedLockedCakeVault, deserializedFlexibleSideCakeVault) {
    var pools = poolsWithUserDataLoading.pools, userDataLoaded = poolsWithUserDataLoading.userDataLoaded;
    var cakePool = pools.find(function(pool) {
        return !pool.isFinished && pool.sousId === 0;
    });
    var withoutCakePool = pools.filter(function(pool) {
        return pool.sousId !== 0;
    });
    var cakeAutoVault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedLockedCakeVault), {
        vaultKey: types/* VaultKey.CakeVault */.om.CakeVault,
        userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedLockedCakeVault.userData)
    });
    var lockedVaultPosition = (0,utils_cakePool/* getVaultPosition */.cP)(deserializedLockedCakeVault.userData);
    var hasFlexibleSideSharesStaked = deserializedFlexibleSideCakeVault.userData.userShares.gt(0);
    var cakeAutoFlexibleSideVault = lockedVaultPosition > utils_cakePool/* VaultPosition.Flexible */.PS.Flexible || hasFlexibleSideSharesStaked ? [
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedFlexibleSideCakeVault), {
            vaultKey: types/* VaultKey.CakeFlexibleSideVault */.om.CakeFlexibleSideVault,
            userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedFlexibleSideCakeVault.userData)
        }), 
    ] : [];
    return {
        pools: [
            cakeAutoVault
        ].concat((0,_to_consumable_array/* default */.Z)(cakeAutoFlexibleSideVault), (0,_to_consumable_array/* default */.Z)(withoutCakePool)),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolWithKeySelector = function(vaultKey) {
    return (0,reselect_es/* createSelector */.P1)(poolsWithVaultSelector, function(param) {
        var pools = param.pools;
        return pools.find(function(p) {
            return p.vaultKey === vaultKey;
        });
    });
};
var ifoCreditSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfoUserCredit
], function(ifoUserCredit) {
    return new (bignumber_default())(ifoUserCredit);
});
var ifoCeilingSelector = (0,reselect_es/* createSelector */.P1)([
    selectIfo
], function(ifoData) {
    return new (bignumber_default())(ifoData.ceiling);
});

;// CONCATENATED MODULE: ./src/state/pools/hooks.ts















var lPoolAddresses = pools/* livePools.filter */.$$.filter(function(param) {
    var sousId = param.sousId;
    return sousId !== 0;
}).map(function(param) {
    var earningToken = param.earningToken;
    return earningToken.address;
});
// Only fetch farms for live pools
var getActiveFarms = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chainId) {
        var farmsConfig;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,constants.getFarmConfig)(chainId);
                case 2:
                    farmsConfig = _ctx.sent;
                    return _ctx.abrupt("return", farmsConfig.filter(function(param) {
                        var token = param.token, pid = param.pid, quoteToken = param.quoteToken;
                        return pid !== 0 && (token.symbol === "BUSD" && quoteToken.symbol === "WBNB" || lPoolAddresses.find(function(poolAddress) {
                            return poolAddress === token.address;
                        }));
                    }).map(function(farm) {
                        return farm.pid;
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActiveFarms(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchPublicPoolsData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var farmFlag = (0,useFeatureFlag/* useFeatureFlag */.y)(useFeatureFlag/* featureFarmApiAtom */.x);
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function(currentBlock) {
        var fetchPoolsDataWithFarms = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var activeFarms;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getActiveFarms(chainId);
                        case 2:
                            activeFarms = _ctx.sent;
                            _ctx.next = 5;
                            return dispatch((0,farms/* fetchFarmsPublicDataAsync */.eG)({
                                pids: activeFarms,
                                chainId: chainId,
                                flag: farmFlag
                            }));
                        case 5:
                            (0,es/* batch */.dC)(function() {
                                dispatch((0,state_pools/* fetchPoolsPublicDataAsync */.ht)(currentBlock, chainId));
                                dispatch((0,state_pools/* fetchPoolsStakingLimitsAsync */.E$)());
                            });
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchPoolsDataWithFarms() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPoolsDataWithFarms();
    }, [
        dispatch,
        chainId,
        farmFlag
    ]);
};
var usePool = function(sousId) {
    var poolWithUserDataLoadingSelector = (0,react.useMemo)(function() {
        return makePoolWithUserDataLoadingSelector(sousId);
    }, [
        sousId
    ]);
    return (0,es/* useSelector */.v9)(poolWithUserDataLoadingSelector);
};
var usePoolsWithVault = function() {
    return (0,es/* useSelector */.v9)(poolsWithVaultSelector);
};
var useDeserializedPoolByVaultKey = function(vaultKey) {
    var vaultPoolWithKeySelector = (0,react.useMemo)(function() {
        return makeVaultPoolWithKeySelector(vaultKey);
    }, [
        vaultKey
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolWithKeySelector);
};
var usePoolsPageFetch = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    useFetchPublicPoolsData();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        (0,es/* batch */.dC)(function() {
            dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)());
            dispatch((0,state_pools/* fetchCakeFlexibleSideVaultPublicData */.i)());
            dispatch((0,state_pools/* fetchIfoPublicDataAsync */.aG)());
            if (account) {
                dispatch((0,state_pools/* fetchPoolsUserDataAsync */.XK)(account));
                dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                    account: account
                }));
                dispatch((0,state_pools/* fetchCakeFlexibleSideVaultUserData */.dU)({
                    account: account
                }));
            }
        });
    }, [
        account,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        (0,es/* batch */.dC)(function() {
            dispatch((0,state_pools/* fetchCakeVaultFees */.HX)());
            dispatch((0,state_pools/* fetchCakeFlexibleSideVaultFees */.qd)());
        });
    }, [
        dispatch
    ]);
};
var useCakeVaultUserData = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        if (account) {
            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                account: account
            }));
        }
    }, [
        account,
        dispatch
    ]);
};
var useFetchIfo = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        (0,es/* batch */.dC)(function() {
            dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)());
            dispatch((0,state_pools/* fetchIfoPublicDataAsync */.aG)());
            if (account) {
                dispatch((0,state_pools/* fetchPoolsUserDataAsync */.XK)(account));
                dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                    account: account
                }));
                dispatch((0,state_pools/* fetchUserIfoCreditDataAsync */.Ck)(account));
            }
        });
    }, [
        dispatch,
        account
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,state_pools/* fetchCakeVaultFees */.HX)());
    }, [
        dispatch
    ]);
};
var useCakeVault = function() {
    return useVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault);
};
var useVaultPoolByKey = function(key) {
    var vaultPoolByKey = (0,react.useMemo)(function() {
        return makeVaultPoolByKey(key);
    }, [
        key
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolByKey);
};
var useIfoCredit = function() {
    return (0,es/* useSelector */.v9)(ifoCreditSelector);
};
var useIfoCeiling = function() {
    return (0,es/* useSelector */.v9)(ifoCeilingSelector);
};


/***/ }),

/***/ 23702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IM": function() { return /* binding */ isStaked; },
/* harmony export */   "PS": function() { return /* binding */ VaultPosition; },
/* harmony export */   "cP": function() { return /* binding */ getVaultPosition; },
/* harmony export */   "p1": function() { return /* binding */ isLocked; }
/* harmony export */ });
/* unused harmony exports isLockedEnd, isAfterBurning */
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62712);

var isStaked = function(param) {
    var userShares = param.userShares;
    return userShares && userShares.gt(0);
};
var isLocked = function(param) {
    var userShares = param.userShares, locked = param.locked;
    return isStaked({
        userShares: userShares
    }) && Boolean(locked) // && !isAfter(new Date(lockEndTime * 1000), new Date())
    ;
};
var isLockedEnd = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() >= parseInt(lockEndTime) * 1000 && Date.now() <= new Date(parseInt(lockEndTime) * 1000).getTime() + config_constants_pools__WEBPACK_IMPORTED_MODULE_0__/* .UNLOCK_FREE_DURATION */ .by * 1000;
};
var isAfterBurning = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() > new Date(parseInt(lockEndTime) * 1000).getTime() + config_constants_pools__WEBPACK_IMPORTED_MODULE_0__/* .UNLOCK_FREE_DURATION */ .by * 1000;
};
var VaultPosition;
(function(VaultPosition) {
    VaultPosition[VaultPosition["None"] = 0] = "None";
    VaultPosition[VaultPosition["Flexible"] = 1] = "Flexible";
    VaultPosition[VaultPosition["Locked"] = 2] = "Locked";
    VaultPosition[VaultPosition["LockedEnd"] = 3] = "LockedEnd";
    VaultPosition[VaultPosition["AfterBurning"] = 4] = "AfterBurning";
})(VaultPosition || (VaultPosition = {}));
var getVaultPosition = function(params) {
    if (isAfterBurning(params)) {
        return VaultPosition.AfterBurning;
    }
    if (isLockedEnd(params)) {
        return VaultPosition.LockedEnd;
    }
    if (isLocked(params)) {
        return VaultPosition.Locked;
    }
    if (isStaked(params)) {
        return VaultPosition.Flexible;
    }
    return VaultPosition.None;
};


/***/ }),

/***/ 51063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69589);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63850);






var ColoredWordHeading = function(_param) {
    var text = _param.text, firstColor = _param.firstColor, _mb = _param.mb, mb = _mb === void 0 ? "24px" : _mb, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "text",
        "firstColor",
        "mb"
    ]);
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().theme;
    var split = text.split(" ");
    var firstWord = split[0];
    var remainingWords = split.slice(1).join(" ");
    var ref;
    var displayedColor = (ref = theme.colors[firstColor]) !== null && ref !== void 0 ? ref : theme.colors.secondary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        scale: "xl",
        mb: mb
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                style: {
                    color: displayedColor
                },
                children: [
                    firstWord,
                    " "
                ]
            }),
            remainingWords
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ColoredWordHeading);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3990,8147,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);